export default __webpack_public_path__ + "static/media/Asthma-1.449eefaa.jpg";